module.exports = __webpack_public_path__ + "img/a75f886359a212955d8362b7dde5eed7.png";